import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

export default function Home6() {
  return (
    <div
      className="row Home-area5"
      style={{ margin: "0px", padding: "0px 50px" }}
    >
      <div className="col-12 Home-main-area5">
        <div
          className="row col-12 desktop"
          style={{
            "-webkit-box-pack": "center",
            "-webkit-justify-content": "center",
            "-ms-flex-pack": "center",
            "justify-content": "center",
            "-webkit-text-align": "center",
            "text-align": "center",
            color: "white",
          }}
        >
          <h2>Customer Speak</h2>
        </div>
        <div
          className="row col-12 mobile"
          style={{
            "-webkit-box-pack": "center",
            "-webkit-justify-content": "center",
            "-ms-flex-pack": "center",
            "justify-content": "center",
            "-webkit-text-align": "center",
            "text-align": "center",
            color: "white",
            padding: "0px 0px 0px 30px",
          }}
        >
          <h3>Customer Speak</h3>
        </div>
        {/* === desktop === */}
        <div className="desktop">
          <OwlCarousel
            className="owl-theme"
            loop={true}
            margin={10}
            nav
            items={2}
            dots={false}
            autoplay={true}
          >
            <div className="item white_box">
              <p style={{ "font-weight": "400" }}>
                I am currently studying in Australia and doing my master's.
                Going abroad for education was a tough choice to make, but the
                team of GetCredit helped us throughout the process and made it
                possible for me.
              </p>
              <p style={{ "font-weight": "600" }}>Harsh Kumar</p>
              <p
                style={{
                  "font-weight": "400",
                  "margin-top": "-12px",
                  "margin-bottom": "0px",
                }}
              >
                Mumbai
              </p>
            </div>

            <div className="item white_box">
              <p style={{ "font-weight": "400" }}>
                I took a loan for home renovation from GetCredit and helped me
                plan my future expenses by giving me the choice to choose my EMI
                amount according to my preferences.
              </p>
              <p style={{ "font-weight": "600" }}>Ishita Singh</p>
              <p
                style={{
                  "font-weight": "400",
                  "margin-top": "-12px",
                  "margin-bottom": "0px",
                }}
              >
                Chandigarh
              </p>
            </div>

            <div className="item white_box">
              <p style={{ "font-weight": "400" }}>
                I was in urgent need of money for my parent's medical expenses
                and applied for a personal loan from GetCredit. The entire
                process was online and quick. I received money within 24 hours.
              </p>
              <p style={{ "font-weight": "600" }}>Kuldeep Singh</p>
              <p
                style={{
                  "font-weight": "400",
                  "margin-top": "-12px",
                  "margin-bottom": "0px",
                }}
              >
                Punjab
              </p>
            </div>

            <div className="item white_box">
              <p style={{ "font-weight": "400" }}>
                I am currently studying in Australia and doing my master's.
                Going abroad for education was a tough choice to make, but the
                team of GetCredit helped us throughout the process and made it
                possible for me.
              </p>
              <p style={{ "font-weight": "600" }}>Abhishek Mondal</p>
              <p
                style={{
                  "font-weight": "400",
                  "margin-top": "-12px",
                  "margin-bottom": "0px",
                }}
              >
                Mumbai
              </p>
            </div>

            <div className="item white_box">
              <p style={{ "font-weight": "400" }}>
                I took a loan for home renovation from GetCredit and helped me
                plan my future expenses by giving me the choice to choose my EMI
                amount according to my preferences.
              </p>
              <p style={{ "font-weight": "600" }}>Ishita Singh</p>
              <p
                style={{
                  "font-weight": "400",
                  "margin-top": "-12px",
                  "margin-bottom": "0px",
                }}
              >
                Chandigarh
              </p>
            </div>
            <div className="item white_box">
              <p style={{ "font-weight": "400" }}>
                I was in urgent need of money for my parent's medical expenses
                and applied for a personal loan from GetCredit. The entire
                process was online and quick. I received money within 24 hours.
              </p>
              <p style={{ "font-weight": "600" }}>Harsh Kumar</p>
              <p
                style={{
                  "font-weight": "400",
                  "margin-top": "-12px",
                  "margin-bottom": "0px",
                }}
              >
                Punjab
              </p>
            </div>

            <div className="item white_box">
              <p style={{ "font-weight": "400" }}>
                I am currently studying in Australia and doing my master's.
                Going abroad for education was a tough choice to make, but the
                team of GetCredit helped us throughout the process and made it
                possible for me.
              </p>
              <p style={{ "font-weight": "600" }}>Abhishek Mondal</p>
              <p
                style={{
                  "font-weight": "400",
                  "margin-top": "-12px",
                  "margin-bottom": "0px",
                }}
              >
                Mumbai
              </p>
            </div>
          </OwlCarousel>
        </div>
      </div>

      {/* === mobile === */}
      <div className="mobile">
        <OwlCarousel
          className="owl-theme"
          loop={true}
          margin={10}
          nav
          items={1}
          dots={false}
          autoPlay={true}
        >
          <div className="item white_box">
            <p style={{ "font-weight": "400" }}>
              I am currently studying in Australia and doing my master's. Going
              abroad for education was a tough choice to make, but the team of
              GetCredit helped us throughout the process and made it possible for
              me.
            </p>
            <p style={{ "font-weight": "600" }}>Harsh Kumar</p>
            <p
              style={{
                "font-weight": "400",
                "margin-top": "-12px",
                "margin-bottom": "0px",
              }}
            >
              Mumbai
            </p>
          </div>

          <div className="item white_box">
            <p style={{ "font-weight": "400" }}>
              I took a loan for home renovation from GetCredit and helped me plan
              my future expenses by giving me the choice to choose my EMI amount
              according to my preferences.
            </p>
            <p style={{ "font-weight": "600" }}>Ishita Singh</p>
            <p
              style={{
                "font-weight": "400",
                "margin-top": "-12px",
                "margin-bottom": "0px",
              }}
            >
              Chandigarh
            </p>
          </div>

          <div className="item white_box">
            <p style={{ "font-weight": "400" }}>
              I was in urgent need of money for my parent's medical expenses and
              applied for a personal loan from GetCredit. The entire process was
              online and quick. I received money within 24 hours.
            </p>
            <p style={{ "font-weight": "600" }}>Kuldeep Singh</p>
            <p
              style={{
                "font-weight": "400",
                "margin-top": "-12px",
                "margin-bottom": "0px",
              }}
            >
              Punjab
            </p>
          </div>

          <div className="item white_box">
            <p style={{ "font-weight": "400" }}>
              I am currently studying in Australia and doing my master's. Going
              abroad for education was a tough choice to make, but the team of
              GetCredit helped us throughout the process and made it possible for
              me.
            </p>
            <p style={{ "font-weight": "600" }}>Abhishek Mondal</p>
            <p
              style={{
                "font-weight": "400",
                "margin-top": "-12px",
                "margin-bottom": "0px",
              }}
            >
              Mumbai
            </p>
          </div>

          <div className="item white_box">
            <p style={{ "font-weight": "400" }}>
              I took a loan for home renovation from GetCredit and helped me plan
              my future expenses by giving me the choice to choose my EMI amount
              according to my preferences.
            </p>
            <p style={{ "font-weight": "600" }}>Ishita Singh</p>
            <p
              style={{
                "font-weight": "400",
                "margin-top": "-12px",
                "margin-bottom": "0px",
              }}
            >
              Chandigarh
            </p>
          </div>
          <div className="item white_box">
            <p style={{ "font-weight": "400" }}>
              I was in urgent need of money for my parent's medical expenses and
              applied for a personal loan from GetCredit. The entire process was
              online and quick. I received money within 24 hours.
            </p>
            <p style={{ "font-weight": "600" }}>Harsh Kumar</p>
            <p
              style={{
                "font-weight": "400",
                "margin-top": "-12px",
                "margin-bottom": "0px",
              }}
            >
              Punjab
            </p>
          </div>

          <div className="item white_box">
            <p style={{ "font-weight": "400" }}>
              I am currently studying in Australia and doing my master's. Going
              abroad for education was a tough choice to make, but the team of
              GetCredit helped us throughout the process and made it possible for
              me.
            </p>
            <p style={{ "font-weight": "600" }}>Abhishek Mondal</p>
            <p
              style={{
                "font-weight": "400",
                "margin-top": "-12px",
                "margin-bottom": "0px",
              }}
            >
              Mumbai
            </p>
          </div>
        </OwlCarousel>
      </div>
      <div id="why"> </div>
    </div>
  );
}
